module.exports = __webpack_public_path__ + "static/img/ldb_bg.fa1afe9d.png";